import React from "react";
import Chart from "./highcharts/Chart";
import highcharts3d from "highcharts/highcharts-3d";
import Highcharts, { color } from "highcharts";
import { UseContextData } from "../../../context/dateContext";

highcharts3d(Highcharts);

const AlertsBySeverityChart = ({ filter = ["tickets"] }) => {
  const { isDarkTheme } = UseContextData();

  const chartOptions = {
    chart: {
      type: "column",
      height: 330,
      backgroundColor: isDarkTheme ? "#3D3D3D" : "#ffffff",
      options3d: {
        enabled: true,
        alpha: 20,
        beta: 0,
        depth: 100,
      },
    },
    title: {
      text: "",
      align: "left",
    },
    subtitle: {
      text: "",
      align: "left",
    },

    xAxis: {
      categories: [
        "Nov 2023",
        "Dec 2023",
        "Jan 2024",
        "Feb 2024",
        "Mar 2024",
        "Apr 2024",
        "May 2024",
        "Jun 2024",
        "Jul 2024",
        "Aug 2024",
      ],
      labels: {
        skew3d: true,
        style: {
          fontSize: "16px",
          color: isDarkTheme ? "#ffffff" : "#27403F",
        },
      },
    },

    yAxis: {
      min: 0,
      title: {
        text: "Number of alerts",
        style: {
         // fontSize: "16px",
          color: isDarkTheme ? "#ffffff" : "#27403F",
        },
      },
      labels: {
        style: {
          // fontSize: "16px",
          color: isDarkTheme ? "#ffffff" : "#27403F",
        },
      },
    },
    tooltip: {
      pointFormat:
        '<span style="color:{series.color}">{series.name}</span>' +
        ": <b>{point.y}</b> ({point.percentage:.0f}%)<br/>",
      shared: true,
    },
    plotOptions: {
      column: {
        depth: 25,
        stacking: "normal",
        dataLabels: {
          enabled: false,
          format: "{point.percentage:.0f}",
        },
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: true,
      itemStyle: {
        color: isDarkTheme ? "#ffffff" : "#27403F",
      },
    },
    series: [
      {
        name: "Error",
        data: [1, 0, 0, 0, 0, 0, 10, 426, 388, 924],
        color: "#ff0000",
      },
      {
        name: "Warning",
        data: [0, 0, 0, 6, 15, 29, 957, 465, 455, 909],
        color: "#ffcc00",
      },
      {
        name: "Info",
        data: [0, 2, 3, 10, 100, 867, 31, 72, 119, 168],
        color: "#2CAFFE",
      },
    ],
  };

  return <Chart options={chartOptions} highcharts={Highcharts} />;
};

export default AlertsBySeverityChart;
